import React, {createContext, useContext, useEffect} from "react";
import {useLocalStorage} from "../hooks";

const DarkModeContext = createContext({})
export const useDarkMode = () => useContext(DarkModeContext);

export function DarkModeProvider({children}) {
    const [darkMode, setDarkMode] = useLocalStorage("darkMode", () => window.matchMedia('(prefers-color-scheme: dark)').matches)

    useEffect(() => {
        const theme = darkMode ? "dark" : "light"
        const htmlElement = document.querySelector('html')
        htmlElement.setAttribute("data-bs-theme", theme);
        htmlElement.setAttribute("data-theme", theme); // Check if it is necessary
    }, [darkMode]);

    function toggleDarkMode() {
        setDarkMode(prevDarkMode => !prevDarkMode)
    }

    return (
        <DarkModeContext.Provider value={{darkMode, toggleDarkMode}}>
            {children}
        </DarkModeContext.Provider>
    )
}
